import {
  LoadboardChoice,
  ShipmentDispatchBriefDispatchType,
} from '#/shared/api/generated/shipment/models'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'

export interface ShipmentDispatchTargets {
  hasCentral: boolean
  hasSuper: boolean
  hasMultiple: boolean
  loadboardChoice: LoadboardChoice
}

export function getShipmentDispatchTargets(
  shipment: ShipmentDetail | undefined,
): ShipmentDispatchTargets {
  const dispatches = shipment?.dispatches ?? []
  const hasCentral = dispatches.some(
    (d) => d.dispatch_type === ShipmentDispatchBriefDispatchType.central,
  )
  const hasSuper = dispatches.some(
    (d) => d.dispatch_type === ShipmentDispatchBriefDispatchType.super,
  )
  const hasMultiple = hasCentral && hasSuper
  const loadboardChoice = pickLoadboardChoice({ hasCentral, hasSuper })
  return { hasCentral, hasSuper, hasMultiple, loadboardChoice }
}

export function isPostedToLoadboard(
  shipment: ShipmentDetail | undefined,
): boolean {
  const { hasCentral, hasSuper } = getShipmentDispatchTargets(shipment)
  return hasCentral || hasSuper
}

export function postedBadgeLabelKey({
  hasCentral,
  hasSuper,
}: ShipmentDispatchTargets): string | undefined {
  if (hasCentral && hasSuper) return 'detailSidebar.postedToCdSd'
  if (hasCentral) return 'detailSidebar.postedToCd'
  if (hasSuper) return 'detailSidebar.postedToSd'
  return undefined
}

// Repost/delete must target only the board(s) the shipment is actually posted
// to — a super-only shipment must not also hit Central Dispatch.
function pickLoadboardChoice({
  hasCentral,
  hasSuper,
}: {
  hasCentral: boolean
  hasSuper: boolean
}): LoadboardChoice {
  if (hasCentral && hasSuper) return LoadboardChoice.both
  if (hasSuper) return LoadboardChoice.super
  return LoadboardChoice.central
}
